import React from 'react';

export const CountContext = React.createContext();

//export const API_URL ="https://wrpl.inobetasolutions.com:6007/"
export const API_URL ="https://associates-online.wockhardthospitals.com:6007/"


export const Agora_chat_appKey = '611241525#1435392';

export const profile_img = "https://regenext.s3.dualstack.eu-north-1.amazonaws.com/images/";